define("calendar/resources/bttp", ["exports", "@ember/service", "@ember/utils", "ember-concurrency-decorators", "ember-concurrency-ts", "ember-resources/util/ember-concurrency", "ember-resources/core", "moment", "later/utils/fetch", "later/utils/constants"], function (_exports, _service, _utils, _emberConcurrencyDecorators, _emberConcurrencyTs, _emberConcurrency, _core, _moment, _fetch, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _clearBttpTimeSlots, _createLegacyTimeSlot, _createTimeSlot, _filterLegacyBttpTimeSlots, _generateReportErrorText, _handleReportErrors;

  0; //eaimeta@70e063a35619d71f0,"@ember/service",0,"@ember/utils",0,"ember-concurrency-decorators",0,"ember-concurrency-ts",0,"ember-resources/util/ember-concurrency",0,"ember-resources/core",0,"moment",0,"later/utils/fetch",0,"later/utils/constants"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  // Type guard for LegacyBttpInstance
  function isLegacyBttp(_bttp, isLegacy) {
    return isLegacy;
  }

  const ERROR_MESSAGES = {
    MISSING_METRICS: 'Missing metrics',
    NOT_ENOUGH_POSTS: 'Not enough posts to run',
    TIMESLOT_ERROR: 'Error fetching best timeslots'
  };
  const ERROR_CODES = {
    DATA_MALFORMED: 'input_data_malformed',
    MISSING_METRICS: 'missing_metrics',
    NOT_ENOUGH_POSTS: 'not_enough_posts'
  };
  let BttpResource = (_class = (_clearBttpTimeSlots = /*#__PURE__*/new WeakSet(), _createLegacyTimeSlot = /*#__PURE__*/new WeakSet(), _createTimeSlot = /*#__PURE__*/new WeakSet(), _filterLegacyBttpTimeSlots = /*#__PURE__*/new WeakSet(), _generateReportErrorText = /*#__PURE__*/new WeakSet(), _handleReportErrors = /*#__PURE__*/new WeakSet(), class BttpResource extends _core.Resource {
    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _handleReportErrors);

      _classPrivateMethodInitSpec(this, _generateReportErrorText);

      _classPrivateMethodInitSpec(this, _filterLegacyBttpTimeSlots);

      _classPrivateMethodInitSpec(this, _createTimeSlot);

      _classPrivateMethodInitSpec(this, _createLegacyTimeSlot);

      _classPrivateMethodInitSpec(this, _clearBttpTimeSlots);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "bttp", _descriptor2, this);

      _initializerDefineProperty(this, "errors", _descriptor3, this);

      _initializerDefineProperty(this, "intl", _descriptor4, this);

      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor5, this);

      _initializerDefineProperty(this, "store", _descriptor6, this);

      _defineProperty(this, "fetchTask", (0, _emberConcurrency.task)(this, (0, _emberConcurrencyTs.taskFor)(this._fetchBttpReport), () => {
        var _this$selectedSocialP;

        return [(_this$selectedSocialP = this.selectedSocialProfiles.firstProfile) === null || _this$selectedSocialP === void 0 ? void 0 : _this$selectedSocialP.id];
      }));
    }

    get bttpTimeSlots() {
      return this.socialProfile.timeSlots.filter(timeSlot => timeSlot.isBttp);
    }

    get socialProfile() {
      return this.selectedSocialProfiles.firstProfile;
    }

    get multipleProfilesSelected() {
      return this.selectedSocialProfiles.hasMultipleSelected;
    }

    *_requestData(report) {
      if ((0, _utils.isNone)(report.url)) {
        return {
          error: this.intl.t('bttp.errors.missing_s3_url')
        };
      }

      try {
        var _parsedData$data, _parsedData$data$bttp;

        const {
          LEGACY
        } = _constants.BTTP_VERSIONS;
        const url = report.s3SignedUrl;
        const rawData = yield (0, _fetch.fetch)(url);
        const parsedData = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;
        const isLegacy = parsedData.version === LEGACY;

        _classPrivateMethodGet(this, _clearBttpTimeSlots, _clearBttpTimeSlots2).call(this);

        (_parsedData$data = parsedData.data) === null || _parsedData$data === void 0 ? void 0 : (_parsedData$data$bttp = _parsedData$data.bttp_data) === null || _parsedData$data$bttp === void 0 ? void 0 : _parsedData$data$bttp.forEach(bttp => {
          isLegacyBttp(bttp, isLegacy) ? _classPrivateMethodGet(this, _createLegacyTimeSlot, _createLegacyTimeSlot2).call(this, bttp) : _classPrivateMethodGet(this, _createTimeSlot, _createTimeSlot2).call(this, bttp);
        });
        return parsedData;
      } catch (error) {
        this.errors.handleAjax(error);
      }
    }

    *_fetchBttpReport() {
      var _reportData$error_dat, _reportData$error_dat2;

      const {
        LEGACY
      } = _constants.BTTP_VERSIONS;
      const bttpReportUnavailable = !this.bttp.canBttp || this.multipleProfilesSelected || !this.bttp.isValidSocialProfile; // Note: If 'findAll' is replaced by 'query' with the expected params, this task seems to run repeatedly
      // without caching the results, I'm still investigating this.

      const reports = yield this.store.findAll('analyticsReport');
      const filteredReports = reports.filter(report => {
        var _this$socialProfile;

        // Note: Typescript prevents us from calling report.get('socialProfile.id')
        const socialProfile = report.get('socialProfile');
        return report.name === this.bttp.analyticsReportName && socialProfile.get('id') === ((_this$socialProfile = this.socialProfile) === null || _this$socialProfile === void 0 ? void 0 : _this$socialProfile.id);
      });
      const report = filteredReports.firstObject; // Note: If bttp reports aren't valid for this account, or user hasn't manually triggered a
      // report in the past, no report will exist

      if (bttpReportUnavailable || !report) {
        return {};
      }

      const reportData = yield (0, _emberConcurrencyTs.taskFor)(this._requestData).perform(report);

      _classPrivateMethodGet(this, _handleReportErrors, _handleReportErrors2).call(this, reportData, report);

      const isLegacy = (reportData === null || reportData === void 0 ? void 0 : reportData.version) === LEGACY;
      const bttpReport = yield { ...reportData,
        numOfFollowers: this.socialProfile.followedBy,
        numOfPosts: reportData === null || reportData === void 0 ? void 0 : (_reportData$error_dat = reportData.error_data) === null || _reportData$error_dat === void 0 ? void 0 : (_reportData$error_dat2 = _reportData$error_dat.data) === null || _reportData$error_dat2 === void 0 ? void 0 : _reportData$error_dat2.num_of_posts,
        reportErrorText: reportData ? _classPrivateMethodGet(this, _generateReportErrorText, _generateReportErrorText2).call(this, reportData) : null,
        requiredBttpPostData: 50,
        requiredFollowerCount: 100,
        timeSlots: isLegacy ? _classPrivateMethodGet(this, _filterLegacyBttpTimeSlots, _filterLegacyBttpTimeSlots2).call(this) : this.bttpTimeSlots
      };
      return bttpReport;
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bttp", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "_requestData", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "_requestData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_fetchBttpReport", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "_fetchBttpReport"), _class.prototype)), _class);
  _exports.default = BttpResource;

  function _clearBttpTimeSlots2() {
    this.bttpTimeSlots.forEach(timeSlot => timeSlot.deleteRecord());
  }

  function _createLegacyTimeSlot2(_ref) {
    let {
      score,
      val
    } = _ref;
    const timeSlot = this.store.createRecord('time-slot', {
      socialProfile: this.socialProfile,
      slotType: 'bttp',
      score
    });
    timeSlot.setFromMinuteOfWeek(val);
  }

  function _createTimeSlot2(_ref2) {
    let {
      wday,
      hour
    } = _ref2;
    // Note: Moment objects are initialized with a timezone based on the users computer settings.
    // Immediate BTTP day/hour is PST/PDT by default, timeslots are processed in full-calendar as UTC (default for legacy BTTP and quick slots)
    // As a result, we need to convert the 'wday' and 'hour' in the BTTP report from the users initial timezone, to PST/PDT, to UTC before saving them
    // to ensure they're correctly processed.
    const initialTimeZone = 'America/Vancouver';

    const utcDateTime = _moment.default.tz(initialTimeZone).day(wday).hour(hour).utc();

    this.store.createRecord('time-slot', {
      hour: utcDateTime.hour(),
      minute: 0,
      socialProfile: this.socialProfile,
      slotType: 'bttp',
      wday: utcDateTime.day()
    });
  }

  function _filterLegacyBttpTimeSlots2() {
    const minDist = 60 * 4;
    const rawTimeSlots = this.bttpTimeSlots.sort((a, b) => b.scoreOrZero - a.scoreOrZero);
    const timeSlots = rawTimeSlots.reduce((accumulator, timeSlot) => {
      const isInvalid = accumulator.some(otherTimeSlot => timeSlot.diff(otherTimeSlot) < minDist);

      if (!isInvalid) {
        accumulator.pushObject(timeSlot);
      }

      return accumulator;
    }, []);
    return timeSlots.slice(0, _constants.NUM_BTTP_SLOTS);
  }

  function _generateReportErrorText2(reportData) {
    const {
      error,
      errorCode
    } = reportData;

    if (errorCode === ERROR_CODES.NOT_ENOUGH_POSTS || error !== null && error !== void 0 && error.includes(ERROR_MESSAGES.NOT_ENOUGH_POSTS)) {
      return this.intl.t('bttp.errors.not_enough_posts_details');
    }

    if ((0, _utils.isPresent)(error)) {
      return error;
    }

    return errorCode;
  }

  function _handleReportErrors2(reportData, report) {
    if (!reportData) {
      const errorMessage = this.intl.t('bttp.errors.unable_to_fetch');
      return this.errors.log(errorMessage, report);
    }
  }
});